import React from "react";
import { Modal, Table, Divider, Typography, message } from "antd";
import Button from "../../../shared/globalStyling/Button";
import { formatDate } from "../../Creatives/utils";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import MediaFetcher from "../../Creatives/library/MediaFetcher";
import { Carousel } from "antd";
import { filterAdGroupsByMediaCompatibility } from "../../Creatives/utils/mediaUtils";

const AddVideosModal = ({
  ids,
  adGroupModalVisible,
  setAdGroupModalVisible,
  setAdGroupModal,
  adGroupCreatives,
  selectedAdUnits,
  handleAssignAdUnits,
  setSelectedAdGroupIds,
  selectedAdGroupIds,
  setAssigning,
}) => {
  const PrevArrow = props => {
    const { className, style, onClick } = props;
    return (
      <LeftOutlined
        className={className}
        style={{ ...style, fontSize: "24px", color: "gray", zIndex: 1 }}
        onClick={onClick}
      />
    );
  };

  const NextArrow = props => {
    const { className, style, onClick } = props;
    return (
      <RightOutlined
        className={className}
        style={{ ...style, fontSize: "24px", color: "gray", zIndex: 1 }}
        onClick={onClick}
      />
    );
  };

  // Filter for video-compatible ad groups (empty or containing videos)
  const videoAdGroups = filterAdGroupsByMediaCompatibility(adGroupCreatives, "VIDEO");

  const displayAdUnits = [
    {
      title: "Video Ad Unit Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Aspect",
      dataIndex: "aspect",
      key: "aspect",
      render: (text, record) => `${record.width}x${record.height}`,
    },
    {
      title: "File Type",
      dataIndex: "fileType",
      key: "fileType",
    },
    {
      title: "Uploaded At",
      dataIndex: "uploaded",
      key: "uploaded",
      render: text => formatDate(text),
    },
  ];

  const availableAdgroup = [
    {
      title: "Video Ad Group Name",
      dataIndex: "name",
      key: "name",
      width: "20%",
    },
    {
      title: "Ad Units",
      dataIndex: "AD Unit Number",
      key: "Ad Unit Number",
      width: "6%",
      render: (_, record) => record.medias.length,
    },
    {
      title: "Gallery",
      dataIndex: "medias",
      key: "medias",
      render: medias => {
        // Dynamic carousel settings based on number of items
        const mediaArray = Array.isArray(medias) ? medias : [];
        const itemCount = mediaArray.length;
        const slidesToShow = Math.min(itemCount, 3); // Video modals show 3 items max
        const slidesToScroll = Math.min(itemCount, 3);

        const settings = {
          dots: false,
          infinite: itemCount > slidesToShow, // Only infinite if more items than shown
          speed: 500,
          slidesToShow,
          slidesToScroll,
          arrows: itemCount > slidesToShow, // Only show arrows if scrolling is needed
          prevArrow: <PrevArrow />,
          nextArrow: <NextArrow />,
        };

        return (
          <div style={{ width: "45%", maxWidth: "750px", margin: "0 auto" }}>
            <Carousel {...settings}>
              {Array.isArray(medias)
                ? medias.map((media, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100px",
                      }}
                    >
                      <div
                        style={{
                          maxWidth: "100px",
                          maxHeight: "100px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <MediaFetcher
                          mediaKey={media.key}
                          width="100%"
                          height="100px"
                          objectFit="contain"
                          isVideo={true}
                        />
                      </div>
                    </div>
                  ))
                : null}
            </Carousel>
          </div>
        );
      },
    },
    {
      title: "Last Updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: "10%",
      render: text => formatDate(text),
    },
  ];

  return (
    <Modal
      title={`SELECTED VIDEO(S) - ${
        ids && ids.length ? ids.length : 0
      } Video(s) Selected`}
      visible={adGroupModalVisible}
      footer={null}
      width={1000}
      onCancel={() => {
        setAdGroupModalVisible(false);
      }}
    >
      <Table
        columns={displayAdUnits}
        dataSource={selectedAdUnits}
        style={{ maxHeight: 200, overflow: "scroll" }}
        pagination={false}
      />
      <Divider style={{ marginTop: "40px", marginBottom: "30px" }} />
      <Typography.Title level={5}>
        SELECT VIDEO AD GROUP FOR ASSIGNMENT
      </Typography.Title>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          type="primary"
          onClick={() => {
            if (!ids || ids.length === 0) {
              message.warning('No videos selected for assignment');
              return;
            }
            if (!selectedAdGroupIds || selectedAdGroupIds.length === 0) {
              message.warning('Please select at least one ad group');
              return;
            }
            handleAssignAdUnits(selectedAdGroupIds, ids);
            // Modal will be closed by the handleAssignAdUnits function in VideoTab
          }}
          disabled={!selectedAdGroupIds || selectedAdGroupIds.length === 0}
        >
          Assign to Ad Group
        </Button>
        <Button
          type="primary"
          onClick={() => {
            setAdGroupModal(true);
            setAdGroupModalVisible(false); // Close assignment modal when create button is clicked
          }}
        >
          Create New Ad Group
        </Button>
      </div>
      <div style={{ height: 20 }} />
      <Table
        columns={availableAdgroup}
        dataSource={videoAdGroups.map(data => ({ key: data.id, ...data }))}
        rowSelection={{
          type: "checkbox",
          selectedRowKeys: selectedAdGroupIds,
          onChange: selectedRowKeys => {
            setSelectedAdGroupIds(selectedRowKeys);
          },
        }}
      />
    </Modal>
  );
};

export default AddVideosModal;
